import React from 'react';
import { Form, Button } from '@blueprintnyc/bpnyc-common';
import { Toggle } from '@blueprintnyc/bpnyc-common-admin';
import ImageUpload from '@/components/ImageUpload';
import ColorInput from '@/components/ColorInput';
import EventGroupsPicker from '@/components/EventGroupsPicker';
import config from 'config';

const DividerWidgetOptions = props => {
	const {
		event,
		widgetToUpdate,
		handleChange,
		widgetProps,
		onUpdate,
		handleGroupChange,
		targetKeys,
	} = props;
	const signedUrlEndpoint = `${config.baseUrl}/${event.client_id}/events/${event.id}/upload/media/signed_url`;

	return (
		<Form initialValues={widgetToUpdate.props} onChange={handleChange}>
			<div className="WidgetUpdateForm">
				<Form.Item label="Divider Type" name="type">
					<Toggle toggleOptions={['solid', 'dashed', 'custom']} />
				</Form.Item>
				{widgetProps.type === 'custom' ? (
					<Form.Item label="Divider Source" name="source">
						<ImageUpload endpoint={signedUrlEndpoint} imageObj={true} />
					</Form.Item>
				) : (
					<>
						<Form.Item label="Divider Size" name="size">
							<Toggle toggleOptions={['small', 'medium', 'large']} />
						</Form.Item>
						<Form.Item label="Divider Color" name="color">
							<ColorInput />
						</Form.Item>
					</>
				)}
				<h4 className="admin-form-item-label">Group Permissions</h4>
				<div className="groups-picker">
					<EventGroupsPicker
						event={event}
						handleChange={handleGroupChange}
						targetKeys={targetKeys}
					/>
				</div>
			</div>
			<Button type="submit" style={{ marginTop: '15px' }} onClick={() => onUpdate(widgetProps)}>
				Submit
			</Button>
		</Form>
	);
};

export default DividerWidgetOptions;
